import { useLottie } from "lottie-react";
import {
  failedLottieAnimationJson,
  successLottieAnimationJson,
} from "../../assets/lottie";
import PageContainer from "../../components/PageContainer/PageContainer";
import Header from "../../components/atoms/Header";
import { useNavigate, useParams } from "react-router-dom";
import { ROUTES } from "../../config/nav";
import { makeStyles } from "@material-ui/core";
import { COLORS } from "../../assets/theme";
import useButtonStyles from "../../hooks/styles/useButtonStyles";
import useVehicleDetails from "../../hooks/vehicle/useVehicleDetails";
import React from "react";
import { useGetSubmittedChecklistByIdQuery } from "../../redux/checklistStoreAPI";
import DetailVehicleComponent from "../../components/vehicle/DetailVehicleComponent";

type Props = {};

const useStyles = makeStyles({
  container: {
    "& h2": {
      textAlign: "center",
      fontWeight: 700,
      letterSpacing: 1,
      "&.failed": {
        background: COLORS.red_1,
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
      },
      "&.success": {
        background: COLORS.gradientBlueGreen_1,
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
      },
    },
    "& p": {
      textAlign: "center",
      fontWeight: 600,
      maxWidth: 284,
      margin: "8px auto",
      "& span": {
        fontWeight: 700,
        color: COLORS.black_1,
      },
    },
    marginTop: 8,
  },
  table: {
    marginTop: 0,
    "& tbody > tr > td": {
      fontSize: 12,
    },
  },
  tableInspection: {
    marginTop: 0,
    "& tbody > tr > td": {
      fontSize: 12,
      color: COLORS.white,
    },
    borderSpacing: 0,
  },
  statusDetail: {
    padding: 16,
    "&.active": {
      background: COLORS.gradientGreen_2,
      "& div": {
        color: COLORS.white,
      },
    },
    "&.inactive": {
      background: COLORS.gradientRed_1,
      "& div": {
        color: COLORS.white,
      },
    },
    "& div": {
      display: "flex",
      alignItems: "center",
      gap: 4,
      "&.active": { color: COLORS.blue_1 },
      "&.inactive": { color: COLORS.gray_2 },
      "& h5": {
        fontSize: 12,
        fontWeight: "bold",
      },
    },
  },
});

const DetailResultSafetyChecklistPage = (_: Props) => {
  const classes = useStyles();
  const { id } = useParams<"id">();
  const { data: dataResult } = useGetSubmittedChecklistByIdQuery(id ?? "");
  const inspectionResult = dataResult?.inspect_result;
  const navigate = useNavigate();
  const options = React.useMemo(() => {
    if (!inspectionResult)
      return {
        animationData: undefined,
      };
    let data = {
      animationData:
        inspectionResult === "failed"
          ? failedLottieAnimationJson
          : successLottieAnimationJson,
      loop: true,
    };
    return data;
  }, [inspectionResult]);
  const { View } = useLottie(options, { width: 200, margin: "0 auto" });
  const buttonClasses = useButtonStyles();
  const [, status] = useVehicleDetails(dataResult?.internal_id);
  return (
    <PageContainer
      headerNavigationContent={<Header title={`Hasil Inspeksi`} />}
      mainContainerStyle={{
        padding: "16px 0 72px 0",
        minHeight: "100vh",
      }}
      withBackground
    >
      <div>{View}</div>
      <div className={classes.container}>
        {inspectionResult ? (
          inspectionResult === "failed" ? (
            <>
              <h2 className="failed">Tidak Lulus Inspeksi</h2>
              <p>
                Berdasarkan hasil pengisian Periodic Safety Checklist, Status
                kendaraan{" "}
                <span
                  style={{
                    color:
                      status?.toUpperCase() === "ACTIVE"
                        ? COLORS.green_1
                        : COLORS.gray_2,
                  }}
                >
                  {status?.toUpperCase() === "ACTIVE" ? "AKTIF" : "TIDAK AKTIF"}
                </span>
                . Periodic Safety Checklist berlaku sampai 6 bulan kedepan.
              </p>
            </>
          ) : (
            <>
              <h2 className="success">Lulus Inspeksi</h2>
              <p>
                Berdasarkan hasil pengisian Periodic Safety Checklist, Status
                kendaraan{" "}
                <span
                  style={{
                    color:
                      status?.toUpperCase() === "ACTIVE"
                        ? COLORS.green_1
                        : COLORS.gray_2,
                  }}
                >
                  {status?.toUpperCase() === "ACTIVE" ? "AKTIF" : "TIDAK AKTIF"}
                </span>
                . Periodic Safety Checklist berlaku sampai 6 bulan kedepan.
              </p>
            </>
          )
        ) : null}
      </div>
      {dataResult?.internal_id ? (
        <>
          <DetailVehicleComponent
            vehicleId={dataResult?.internal_id}
            isShowFloatingButton={false}
            isShowLastSafetyCheckButton={true}
          />
          <div
            style={{
              display: "inline-grid",
              justifyItems: "center",
              width: "100%",
            }}
          >
            <button
              className={`${buttonClasses.button} secondary`}
              style={{ margin: 16, width: "96%" }}
              onClick={() => navigate(ROUTES.admin)}
            >
              <span>KEMBALI KE HALAMAN DEPAN</span>
            </button>
          </div>
        </>
      ) : null}
    </PageContainer>
  );
};

export default DetailResultSafetyChecklistPage;
